import { render } from "./LoadingMessage.vue?vue&type=template&id=c49ad648"
import script from "./LoadingMessage.vue?vue&type=script&lang=js"
export * from "./LoadingMessage.vue?vue&type=script&lang=js"

import exportComponent from "/home/noe/Dev/atc/agrotecchain_vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__